import { ACTIONS } from './index';
import Plan from '../configs/plan';

export function getPlan() {
    return {
        type: ACTIONS.GET_PLAN,
        payload: Plan
    }
}